import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";
import { ElementType } from "react";

type DeleteConversationProps = {
    deleteConversation: (id: string) => Promise<boolean>
    deleting: string | null;
    setDeleting: (conversationId: string | null) => void;
};

const DeleteConversation: ElementType<DeleteConversationProps> = 
    ({ deleteConversation, deleting, setDeleting }) => {
    
    const confirmDelete = async () => {
        await deleteConversation(deleting!);
        setDeleting(null);
    };
    
    return (
        <Dialog
            open={deleting !== null}
            onClose={() => setDeleting(null)}
            aria-labelledby="delete-dialog-title"
            aria-describedby="delete-dialog-description" >

            <DialogTitle id="delete-dialog-title">
                Confirm Delete
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="delete-dialog-description">
                    Are you sure you want to delete "{deleting}"?
                    This action cannot be undone.
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ p: 2, pt: 1 }}>
                <Button
                    onClick={() => setDeleting(null)}
                    variant="outlined" >
                    Cancel
                </Button>
                <Button
                    onClick={confirmDelete}
                    variant="contained"
                    color="error"
                    autoFocus >
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default DeleteConversation;